import { Skeleton } from '@shared/components/ui/skeleton'
import { Loader2 } from 'lucide-react'

interface LoadingStateProps {
  message?: string
  size?: 'sm' | 'md' | 'lg'
  variant?: 'cards' | 'rows'
}

export function LoadingState({ message, size = 'md', variant = 'cards' }: LoadingStateProps) {
  if (size === 'sm') {
    return (
      <div role="status" className="flex items-center justify-center gap-2 py-4">
        <Loader2 aria-hidden="true" className="size-4 animate-spin text-primary" />
        {message && <p className="text-sm text-muted-foreground">{message}</p>}
      </div>
    )
  }

  if (variant === 'rows') {
    return (
      <div role="status" className="space-y-4 py-2">
        <div
          aria-hidden="true"
          className="divide-y divide-border/60 rounded-2xl border border-border/60 bg-card/60 shadow-sm"
        >
          {[0, 1, 2, 3, 4].map((item) => (
            <div key={item} className="flex items-center gap-3 p-4">
              <Skeleton className="size-10 shrink-0 rounded-full" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-1/3" />
                <Skeleton className="h-3 w-1/2" />
              </div>
              <Skeleton className="hidden h-6 w-20 rounded-full sm:block" />
            </div>
          ))}
        </div>
        {message && <p className="text-center text-sm text-muted-foreground">{message}</p>}
      </div>
    )
  }

  return (
    <div role="status" className="space-y-4 py-2">
      <div aria-hidden="true" className="space-y-3">
        {[0, 1, 2].map((item) => (
          <div
            key={item}
            className="space-y-3 rounded-2xl border border-border/60 bg-card/60 p-5 shadow-sm"
          >
            <Skeleton className="h-5 w-1/3" />
            <Skeleton className="h-4 w-4/5" />
            <div className="flex gap-2">
              <Skeleton className="h-6 w-20 rounded-full" />
              <Skeleton className="h-6 w-16 rounded-full" />
            </div>
          </div>
        ))}
      </div>
      {message && <p className="text-center text-sm text-muted-foreground">{message}</p>}
    </div>
  )
}

LoadingState.displayName = 'LoadingState'
